import { render, staticRenderFns } from "./FichaFuncionarios.vue?vue&type=template&id=0450d618"
import script from "./FichaFuncionarios.vue?vue&type=script&lang=js"
export * from "./FichaFuncionarios.vue?vue&type=script&lang=js"
import style0 from "./FichaFuncionarios.vue?vue&type=style&index=0&id=0450d618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports